import { FC } from "react";
import { Stack } from "@mui/material";
import { AskAIQuestion } from "@/components/pages/common/ask-ai/components/conversation/AskAIQuestion";
import { AskAiAnswer } from "@/components/pages/common/ask-ai/components/conversation/AskAiAnswer";
import { AskAIConversationLoading } from "@/components/pages/common/ask-ai/components/conversation/AskAIConversationLoading";
import { AskAiConversationItem } from "@/store/ask-ai/utils/types";
import { useAppSelector } from "@/store/hooks";
import { askAiLoadingSelector } from "@/store/ask-ai/selectors/askAiLoadingSelector";

interface AskAICollapsableConversationItemProps {
  data: AskAiConversationItem;
  index: number;
  totalCount: number;
}

export const AskAICollapsableConversationItem: FC<
  AskAICollapsableConversationItemProps
> = ({ data, index, totalCount }) => {
  const loading = useAppSelector(askAiLoadingSelector);

  return (
    <Stack borderRadius={2} spacing={2}>
      {data.type === "question" && <AskAIQuestion data={data} />}

      {loading && index === totalCount - 1 && <AskAIConversationLoading />}

      {data.type === "answer" && <AskAiAnswer data={data} />}
    </Stack>
  );
};
